'use es6';

const baseUrl = 'connectedaccounts/v1/feature';
export const enableAccount = (apiClient, emailAddress) => apiClient.post(`${baseUrl}/CRM_EMAIL_INTEGRATION/account/${emailAddress}?state=ENABLED`);